<template>
  <section>
    <div class="editable-section">
      <div class="header-section">
        <div class="title-section">
          <div class="section-icon">
            <slot name="section-icon" />
          </div>
          <div
            class="section-title"
            @click="redirectPage"
          >
            <h3
              :id="title.toLowerCase().replace(' ', '-')"
              v-dompurify-html="title"
            />
            <slot name="suffix-icon" />
          </div>
        </div>

        <template v-if="editable">
          <div
            v-if="!isEditing"
            class="edit-link"
          >
            <a
              href=""
              class="edit-text"
              @click.prevent="setToEditing"
            >
              <slot name="edit-text">
                <span>Edit</span>
              </slot>
              <span class="fa fa-pencil pl-5 mobile-pl-5" />
            </a>
            <a
              v-if="removeable"
              href=""
              @click.prevent="removeItem"
            > Delete&nbsp;<span class="fa fa-trash pl-5 mobile-pl-5" /> </a>
          </div>
          <div
            v-if="isEditing"
            class="edit-link"
          >
            <a
              href=""
              @click.prevent="save"
            > Save&nbsp;<span class="fa fa-save pl-5 mobile-pl-5" /> </a>
            <a
              href=""
              @click.prevent="cancel"
            > Cancel&nbsp;<span class="fa fa-times pl-5 mobile-pl-5" /> </a>
            <a
              v-if="removeable"
              href=""
              @click.prevent="removeItem"
            > Delete&nbsp;<span class="fa fa-trash pl-5 mobile-pl-5" /> </a>
          </div>
        </template>
      </div>
      <hr>
      <slot
        name="section-content"
        :is-editing="isEditing"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  editable: {
    type: Boolean,
    default: true,
  },

  title: {
    type: String,
    default: 'Title',
  },

  removeable: {
    type: Boolean,
    default: false,
  },

  itemIndex: {
    type: Number,
    default: 0,
  },

  formId: {
    type: String,
    default: '',
  },

  activeFormId: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['save', 'edit', 'delete', 'cancel', 'redirect']);

const isEditing = computed(() => {
  if (!props.activeFormId) {
    return false;
  }

  return props.activeFormId === props.formId;
});

const setToEditing = async () => {
  emit('edit', props.formId, props.title);
};

const save = () => {
  emit('save');
};

const cancel = () => {
  emit('cancel', props.formId);
};

const removeItem = () => {
  emit('delete', props.formId, props.itemIndex);
};

const redirectPage = () => {
  emit('redirect');
};
</script>

<style lang="scss">
.editable-section {
  hr {
    margin: 10px -10px;
  }
  .header-section {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    .title-section {
      display: flex;
      align-items: center;
      h3 {
        margin-bottom: 0;
        font-size: 20px;
      }
      .section-icon {
        margin-left: -10px;
        i {
          font-size: 20px;
          margin-right: 5px;
        }
      }
      .section-title {
        display: flex;
        cursor: pointer;
      }
    }
  }
  .edit-link > a {
    color: #00ff99;
    padding-left: 1.2rem;
    &:first-child {
      padding-left: 0;
    }
  }
}
</style>
